import React from 'react'
import DeprecatedWidget from './DeprecatedWidget'
import { isFunction } from './Utils'

export const Sizes = {
  square: {
    tiny: {
      w: 2,
      h: 4
    },
    small: {
      w: 3,
      h: 6
    },
    medium: {
      w: 4,
      h: 8
    },
    large: {
      w: 5,
      h: 10
    },
    huge: {
      w: 6,
      h: 12
    }
  },
  banner: {
    tiny: {
      w: 4,
      h: 4
    },
    small: {
      w: 4,
      h: 6
    },
    medium: {
      w: 6,
      h: 6
    },
    large: {
      w: 12,
      h: 6
    },
    huge: {
      w: 12,
      h: 10
    }
  },
  Unlimited: {

  }
}

export const VariableSize = (initial, min, max) => ({
  ...initial,
  minW: min.w,
  minH: min.h,
  maxW: max.w,
  maxH: max.h
})

class WidgetDefinition{
  static Sizes = Sizes;
  static VariableSize = VariableSize;
  /**
   *
   * @param {string} name - A unique name by which to identify the type of widget.
   * @param {reactClass} type - The component to render.
   * @param {object} optionalArgs - Additional parameters to the component.
   */
  constructor (name, type, optionalArgs) {
    this.name = name;
    this.type = type;
    this.info = optionalArgs && optionalArgs.info ? optionalArgs.info : ''
    if(optionalArgs && optionalArgs.defaultGridItemProps){
      this.defaultGridItemProps = optionalArgs.defaultGridItemProps;
    } else if(isFunction(type.defaultGridItemProps)){
      this.defaultGridItemProps = type.defaultGridItemProps();
    } else if(type.defaultGridItemProps){
      this.defaultGridItemProps = type.defaultGridItemProps;
    } else {
      console.warn("You should define defaultGridItemProps on ", type);
      this.defaultGridItemProps = {
        w: 3,
        h: 3
      };
    }
  }

  equals(other){
    return other != null &&
           this.name === other.name;
  }


  matchesSerialized(widget){
    return this.name === widget.name;
  }
}

class Widget{
  constructor(id, definition){
    this.id = id;
    this.definition = definition;
    this.className = definition.name;
  }

  get gridProps(){
    if(!this.definition || !this.definition.defaultGridItemProps){
      return {w: 2, h: 3}
    }
    return this.definition.defaultGridItemProps;
  }

  matchesDefinition(other){
    return this.definition.equals(other);
  }

}

class SerializedWidget{
  constructor(id, name){
    this.id = id;
    this.name = name;
  }

  matchesDefinition(widget){
    return this.name === widget.name;
  }
}

const MissingWidget = (name) => (props) => (<DeprecatedWidget name={name} widgetProps={props} />);
const MissingDefinition  = (name) => new WidgetDefinition("unknown", MissingWidget(name), {
  defaultGridItemProps: {w: 4, h: 8}
});

export default WidgetDefinition;
export { Widget, SerializedWidget, MissingDefinition }
